import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Select from "@material-ui/core/Select";

import Input from "./SelectInput";
import Icon from "../Icon";
import { DropDownIconComponent } from "./icons";

import MenuProps from "./menuProps";

import styles, {
  analyzeTemplate,
  select_class_for_menu
} from "./common_styles";

const ComplexSelect = ({
  classes: {
    formControl,
    formControl_with_border,
    colorSecondary,
    checked,
    disabled,
    select,
    setBold,
    root,
    rootOpen,
    menuItem,
    listItemText,
    set_icon_pos,
    disable_padding_right,
    single_text_class,
    disable_margins,
    disable_padding,
    selected,
    full_width_input,
    ...other_classes
  },
  selected_value,
  values,
  handleChange,
  name,
  open,
  handleOpen,
  handleClose,
  icon_component,
  icon_adornment_size,
  select_disabled,
  im_hovered_upon,
  selected_field,
  dropdown_icon,
  dropdown_tooltip_text,
  type,
  menu_item_props,
  dense,
  input_class,
  className,
  full_width_xs,
  drop_down_menu_button,
  menuProps,
  ...props
}) => {
  //  ${full_width_xs ? other_classes[`full_width_input${icon_component ? `_${icon_adornment_size}` : ''}`]:""}
  return (
    <Select
      value={selected_value}
      onChange={handleChange}
      disabled={select_disabled}
      input={
        <Input
          type={type}
          id="select-native-button"
          className={im_hovered_upon && !drop_down_menu_button ? rootOpen : ""}
          input_class={`
                ${input_class}
              `}
          iconComponent={
            Boolean(icon_component && !(type === "icon")) ? (
              <Icon
                size={icon_adornment_size}
                type={icon_component}
                disabled={select_disabled}
              />
            ) : null
          }
        />
      }
      IconComponent={() => (
        <DropDownIconComponent
          size={type === "icon" ? "md" : "sm"}
          select_disabled={select_disabled}
          dropdown_icon={dropdown_icon}
          dropdown_tooltip_text={dropdown_tooltip_text}
          is_button={drop_down_menu_button}
        />
      )}
      renderValue={selected => analyzeTemplate(selected_field, selected, type)}
      MenuProps={MenuProps({
        paper_class: select_class_for_menu({
          direction: type === "icon" ? "right" : "left",
          fullWidth: full_width_xs,
          classes: other_classes,
          drop_down_menu_button
        }),
        direction: type === "icon" ? "right" : "left",
        ...menuProps
      })}
      name={name}
      classes={{
        root,
        select: select + (type === "icon" ? ` ${disable_padding_right}` : "")
      }}
      onClick={e => handleOpen(e, select_disabled)}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      {...props}
    >
      {values.map(({ name, type: icon_path, IconComponent = Icon }, i) => {
        const is_single_text = Boolean(values.length) && !Boolean(icon_path);

        return (
          <MenuItem
            key={`select-complex-${name}${i}`}
            value={name}
            classes={{
              root: menuItem,
              selected
            }}
            {...menu_item_props}
          >
            {Boolean(icon_path) && (
              <ListItemIcon className={disable_margins}>
                <IconComponent type={icon_path} />
              </ListItemIcon>
            )}
            {
              <ListItemText
                primary={name}
                value={name}
                name={name}
                aria-label={name}
                style={{
                  whiteSpace: "wrap"
                }}
                classes={{
                  root:
                    disable_padding +
                    (is_single_text ? " " + single_text_class : ""),
                  primary: name === selected_value ? setBold : ""
                }}
              />
            }
          </MenuItem>
        );
      })}
    </Select>
  );
};

ComplexSelect.propTypes = {
  classes: PropTypes.shape({
    formControl: PropTypes.string.isRequired,
    formControl_with_border: PropTypes.string.isRequired,
    colorSecondary: PropTypes.string.isRequired,
    checked: PropTypes.string.isRequired,
    disabled: PropTypes.string.isRequired,
    select: PropTypes.string.isRequired,
    setBold: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    rootOpen: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired
  }),
  selected_value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ]).isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon_path: PropTypes.string
    })
  ).isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  open: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon_component: PropTypes.string,
  icon_adornment_size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  select_disabled: PropTypes.bool,
  im_hovered_upon: PropTypes.bool,
  selected_field: PropTypes.string,
  dropdown_icon: PropTypes.string,
  dense: PropTypes.bool,
  input_class: PropTypes.string,
  full_width_xs: PropTypes.bool,
  drop_down_menu_button: PropTypes.bool
};

ComplexSelect.defaultProps = {
  values: [],
  selected_value: "",
  icon_adornment_size: "md",
  selected_field: "selected",
  dropdown_icon: "icon-down-arrow"
};

export default React.memo(withStyles(styles)(ComplexSelect));
